<template>
    <h3 class="title mt-5 text-center">
        <button class="btn rounded-circle border-0 bg-whites" @click="arrowClick()">
        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="42" fill="currentColor" class="bi bi-arrow-left-short" viewBox="0 0 16 16">
            <path fill-rule="evenodd" d="M12 8a.5.5 0 0 1-.5.5H5.707l2.147 2.146a.5.5 0 0 1-.708.708l-3-3a.5.5 0 0 1 0-.708l3-3a.5.5 0 1 1 .708.708L5.707 7.5H11.5a.5.5 0 0 1 .5.5z"></path>
        </svg>
        </button>
        Reset your password
    </h3>
    <div class="border-bottom mb-4"></div>
    <h6 class="title text-center mb-4">Changing your password will sign you out on your devices.</h6>
    <div class="row mb-4">
        <div class="col-sm-4"></div>
        <div class="col-sm-4 list-group-item rounded-3" v-show="one">
            <div class="text mt-3 mb-5"><h5>Enter your current password</h5></div>
            <div class="form-floating input-group">
                <input :type="passwordFieldType" class="form-control" id="password" v-model="user.PASSWORD">
                <button class="btn border bg-white border border-radius-right rounded-end border-start-0" aria-label="Show/hide entered password" @click="showPassword()">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" class="bi bi-eye-fill" viewBox="0 0 16 16" v-show="passwordStatusType">
                        <path d="M10.5 8a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0z"/>
                        <path d="M0 8s3-5.5 8-5.5S16 8 16 8s-3 5.5-8 5.5S0 8 0 8zm8 3.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7z"/>
                    </svg>
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" class="bi bi-eye-slash-fill" viewBox="0 0 16 16" v-show="!passwordStatusType">
                        <path d="m10.79 12.912-1.614-1.615a3.5 3.5 0 0 1-4.474-4.474l-2.06-2.06C.938 6.278 0 8 0 8s3 5.5 8 5.5a7.029 7.029 0 0 0 2.79-.588zM5.21 3.088A7.028 7.028 0 0 1 8 2.5c5 0 8 5.5 8 5.5s-.939 1.721-2.641 3.238l-2.062-2.062a3.5 3.5 0 0 0-4.474-4.474L5.21 3.089z"/>
                        <path d="M5.525 7.646a2.5 2.5 0 0 0 2.829 2.829l-2.83-2.829zm4.95.708-2.829-2.83a2.5 2.5 0 0 1 2.829 2.829zm3.171 6-12-12 .708-.708 12 12-.708.708z"/>
                    </svg>
                </button>
                <label for="password">Password</label>
            </div>
            <div class="row">
                <div class="mt-1 mb-3">
                    <div ref="one" class="check red">&nbsp;</div>
                </div>
            </div>
            <div class="row mt-4">
                <div class="col mb-2"></div>
                <div class="col mb-2 d-flex justify-content-end">
                    <button type="button" class="btn btn-dark" @click="verifyPwdClick()">Confirm</button>
                </div>
            </div>
        </div>
        <div class="col-sm-4 list-group-item rounded-3 border-top" v-show="two">
            <div class="text mt-3 mb-5"><h5>Enter your new password</h5></div>
            <div class="form-floating input-group">
                <input :type="passwordFieldType" class="form-control" id="new-password" v-model="this.user.NEW_PASSWORD">
                <button class="btn border bg-white border border-radius-right rounded-end border-start-0" aria-label="Show/hide entered password" @click="showPassword()">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" class="bi bi-eye-fill" viewBox="0 0 16 16" v-show="passwordStatusType">
                        <path d="M10.5 8a2.5 2.5 0 1 1-5 0 2.5 2.5 0 0 1 5 0z"/>
                        <path d="M0 8s3-5.5 8-5.5S16 8 16 8s-3 5.5-8 5.5S0 8 0 8zm8 3.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7z"/>
                    </svg>
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" class="bi bi-eye-slash-fill" viewBox="0 0 16 16" v-show="!passwordStatusType">
                        <path d="m10.79 12.912-1.614-1.615a3.5 3.5 0 0 1-4.474-4.474l-2.06-2.06C.938 6.278 0 8 0 8s3 5.5 8 5.5a7.029 7.029 0 0 0 2.79-.588zM5.21 3.088A7.028 7.028 0 0 1 8 2.5c5 0 8 5.5 8 5.5s-.939 1.721-2.641 3.238l-2.062-2.062a3.5 3.5 0 0 0-4.474-4.474L5.21 3.089z"/>
                        <path d="M5.525 7.646a2.5 2.5 0 0 0 2.829 2.829l-2.83-2.829zm4.95.708-2.829-2.83a2.5 2.5 0 0 1 2.829 2.829zm3.171 6-12-12 .708-.708 12 12-.708.708z"/>
                    </svg>
                </button>
                <label for="new-password">New Password</label>
            </div>
            <div class="form-floating input-group mt-3">
                <input :type="passwordFieldType" class="form-control" id="new-password2" v-model="user.NEW_PASSWORD2">
                <label for="new-password2">Confirm new password</label>
            </div>
            <div class="row">
                <div class="mt-1 mb-3">
                    <div ref="two" class="check red">&nbsp;</div>
                </div>
            </div>
            <div class="row">
                <div class="col mb-2"></div>
                <div class="col d-flex justify-content-end mb-2 mt-3">
                    <button type="button" class="btn btn-dark" @click="resetPwdClick()">Reset</button>
                </div>
            </div>
        </div>
        <div class="col-sm-4"> </div>
    </div>
</template>

<script>
    import { $global, $axios } from "@/dot-ui/index.js";
    // import "@/assets/css/formLayout.css";
    import { router } from '@/routes/index.js';

    export default
    {
        data()
		{
            return {
                user: {
                    USER_NO: sessionStorage.getItem("USER_NO"),
                    USER_ID: sessionStorage.getItem("USER_ID"),
                    PASSWORD: "",
                    NEW_PASSWORD: "",
                    NEW_PASSWORD2: "",
                },
                one: true,
                two: false,
                fromParams: "",
                passwordFieldType: "password",
                passwordStatusType: false,
            }
        },
        created()
        {
            this.fromParams = $global.getUrlParams();
        },
        methods:
        {
            showPassword()
            {
                this.passwordFieldType = this.passwordFieldType != "password" ? "password": "text";
                if (this.passwordFieldType != "password") {
                    this.passwordStatusType = !this.passwordStatusType;
                }
            },
            selectView(target)
            {
                this.one = false;
                this.two = false;

                if(target === "one") {
                    this.one = true;
                }
                if(target === "two") {
                    this.two = true;
                }
            },
            // 비밀번호 확인
            async verifyPwdClick()
            {
                // ?callback=[로그인 후 콜백 URL]&s=[사이트번호]&c=[업체번호]
                // let fromParams = $global.getUrlParams();
                // let fromCallback = this.fromParams.cb;
                let fromSiteNo = this.fromParams.s;
                let fromCompNo = this.fromParams.c;
                let url = "/user-app/v1/sites/" + fromSiteNo + "-" + fromCompNo + "/users/" + this.user.USER_NO + "/verifyPasswd"
                let param = this.user;
                let response = await $axios.post(url, param);

                if (response.status == 200 && response.data.RESULT_CODE == 1) {
                    this.$refs.one.innerHTML = "";
                    this.selectView("two");
                    this.user.PASSWORD = "";

                } else {
                    this.$refs.one.innerHTML = "";
                    response.data.errors.forEach(e => {
                        this.$refs.one.innerHTML += e.msg + "<br />";
                    });
                }
            },
            // 비밀번호 초기화
            async resetPwdClick()
            {
                // ?callback=[로그인 후 콜백 URL]&s=[사이트번호]&c=[업체번호]
                // let fromParams = $global.getUrlParams();
                // let fromCallback = this.fromParams.cb;
                let fromSiteNo = this.fromParams.s;
                let fromCompNo = this.fromParams.c;
                let url = "/user-app/v1/sites/" + fromSiteNo + "-" + fromCompNo + "/users/" + this.user.USER_NO + "/editPasswd"
                let param = this.user;
                let response = await $axios.put(url, param);

                if (response.status == 204) {
                    router.push({
                        path : "/",
                        query: {
                            cb: this.fromParams.cb,
                            s: this.fromParams.s,
                            c: this.fromParams.c
                        },
                    });
                } else {
                    this.$refs.two.innerHTML = "";
                    response.data.errors.forEach(e => {
                        this.$refs.two.innerHTML += e.msg + "<br />";
                    });
                }
            },
            // 뒤로가기 클릭
            arrowClick()
            {
                router.push({
                    path: "/basic",
                    query: {
                        cb: this.fromParams.cb,
                        s: this.fromParams.s,
                        c: this.fromParams.c,
                    },
                });
            },
        }
    }
</script>
<style>
.red {
  color: red;
}
.blue {
  color: blue;
}
.black {
  color: black;
}
</style>
